import { SET_POP_UP } from 'client/constants';

export default function setPopUp(id, data = null) {
	return dispatch => dispatch({ type: SET_POP_UP, payload: { id, data } });
}
